import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { customStyle } from 'helper';
import Select from 'react-select';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

const formatOptions = data => {
  return data.map(item => {
    return {
      label: item.name,
      value: item.name,
      id: item.id,
    };
  });
};

function CreatePermissionModal({
  createPermission,
  formData,
  setFormData,
  getPermissionList,
  id,
  getListPermissions,
  listPermissions,
  creating,
  selectedPermissions
}) {

  const setModal = useContext(ModalContext);

  const profile = getJson('profile') || {};

  const showListOfPermissionsUser = getJson('permissionsList') || [];

  const handleOnSubmit = (e) => {
    e.preventDefault();

    createPermission(id, formData, () => {
      setModal({ isOpen: false });
      getPermissionList(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    getListPermissions();
    getPermissionList(id);
  }, []);

  const listPermissionsOptions = listPermissions.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.attributes.name,
    id: x.id,
  }));


  const filteredPermissionOptions = selectedPermissions.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.attributes.name,
    id: x.id,
  }));

  const filteredPermissions = _.get(profile, 'roles') === 'super_administrator' ? (
    listPermissionsOptions.filter(o1 =>
      !filteredPermissionOptions.find(o2 => +o1.id === +o2.id)
    )) : (
    showListOfPermissionsUser.filter(o1 =>
      !filteredPermissionOptions.find(o2 => +o1.id === +o2.id)
    )
  );

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <Select
              styles={customStyle}
              placeholder="Select Permission"
              onChange={handleOnChangeSelect('name')}
              options={_.get(profile, 'roles') === 'super_administrator' ? filteredPermissions : formatOptions(filteredPermissions)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreatePermissionModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getPermissionList: PropTypes.instanceOf(Function).isRequired,
  createPermission: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  listPermissions: PropTypes.instanceOf(Array).isRequired,
  selectedPermissions: PropTypes.instanceOf(Array).isRequired,
  getListPermissions: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  listPermissions: _.get(api, `${c.GET_LIST_PERMISSION}.list`) || [],
  selectedPermissions: _.get(api, `${c.GET_PERMISSION}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_PERMISSION) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreatePermissionModal);
